var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-block"},[_c('label',{staticClass:"v-label theme--light"},[_vm._v(_vm._s(_vm.label))]),_c('froala',{ref:"textEditor",staticClass:"mt-1",attrs:{"config":_vm.mergedConfig},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }